import image5 from '../images/promo05.webp';
import image6 from '../images/promo06.jpg';

const slides = [
  {
    name: 'More Media Magic in Less Time with Automation & AI',
    slug: 'more-media-magic-in-less-time-with-automation-and-ai',
    caption:
      "The new Automation Engine brings media management to the next level. Set up smart workflows to handle routine tasks — whether it's archiving assets, tagging media, or updating access controls. All without touching a single line of code.",
    category: "What's new",
    image: image5,
  },
  {
    name: 'Control at Your Fingertips',
    slug: 'control-at-your-fingertips',
    caption:
      'Iconik is a safe place for all your creative work. You can store and share files, collaborate on projects, and create your most iconik work ever',
    category: 'Features',
    image: image6,
  },
];

export default slides;
